export default class InvariantFailureException {
  message: string
  constructor(message: string) {
    this.message = message
  }
}
